export const formatNumber = (value, maximumFractionDigits = 0) => {
    const numericValue = Number(value || 0);
    return new Intl.NumberFormat("es-PY", {
        maximumFractionDigits
    }).format(numericValue);
};

export const formatCurrency = (value) => {
    return `Gs. ${formatNumber(value, 0)}`;
};

export const formatPercent = (value) => {
    return `${formatNumber(value, 1)}%`;
};

export const formatPeriodDate = (date) => {
    if (!date) return "";

    return new Intl.DateTimeFormat("es-PY", {
        day: "numeric",
        month: "short",
        year: "numeric"
    }).format(new Date(`${date}T00:00:00`));
};

export const getInitials = (value) => {
    if (!value) return "--";

    return value
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase();
};

export const getComparisonText = (comparison) => {
    if (!comparison) return "";

    if (comparison.percentageChange === null || comparison.percentageChange === undefined) {
        return "sin base";
    }

    const sign = comparison.percentageChange > 0 ? "+" : "";
    return `${sign}${formatNumber(comparison.percentageChange, 1)}%`;
};
